import { Link } from "react-router-dom";
import { SECTIONS } from "@/lib/sections";
import { NewsletterSignup } from "@/components/site/NewsletterSignup";

export const Footer = () => (
  <footer className="mt-28 border-t border-[var(--ink)]" data-testid="site-footer">
    <div className="max-w-5xl mx-auto px-5 sm:px-8 pt-12">
      <div className="max-w-md"><NewsletterSignup id="footer-newsletter" /></div>
    </div>
    <div className="max-w-5xl mx-auto px-5 sm:px-8 py-12 grid gap-10 sm:grid-cols-3">
      <div>
        <p className="font-display text-2xl font-bold">uk<span className="italic font-medium">discovered</span></p>
        <p className="mt-3 text-sm text-[var(--ink-2)] max-w-xs leading-relaxed">
          News and opinion from life in the UK, and around the world. Independent and ad-free.
        </p>
      </div>
      <div className="flex flex-col gap-2 font-ui text-sm">
        <span className="meta mb-1">Sections</span>
        {SECTIONS.map((s) => (
          <Link key={s.slug} to={`/section/${s.slug}`} className="link-quiet" data-testid={`footer-link-${s.slug}`}>{s.name}</Link>
        ))}
      </div>
      <div className="flex flex-col gap-2 font-ui text-sm">
        <span className="meta mb-1">The publication</span>
        <Link to="/about" className="link-quiet" data-testid="footer-link-about">About</Link>
        <Link to="/contact" className="link-quiet" data-testid="footer-link-contact">Contact</Link>
        <Link to="/search" className="link-quiet" data-testid="footer-link-search">Search</Link>
        <Link to="/admin" className="link-quiet text-[var(--ink-3)]" data-testid="nav-link-admin">Admin login</Link>
      </div>
    </div>
    <div className="max-w-5xl mx-auto px-5 sm:px-8 pb-10 meta !tracking-[0.1em]">© {new Date().getFullYear()} ukdiscovered.uk</div>
  </footer>
);
